const HomepageSlideWeather = () => {
    return (
        <>
            <img
                src="./images/homepage_rebrand/slider/cloud.png"
                alt="Privacy widget"
                width="405"
                height="263"
                className="cloud cloud--first"
            />
            <img
                src="./images/homepage_rebrand/slider/cloud.png"
                alt="Privacy widget"
                width="405"
                height="263"
                className="cloud cloud--second"
            />
            <img
                src="./images/homepage_rebrand/slider/cloud.png"
                alt="Privacy widget"
                width="405"
                height="263"
                className="cloud cloud--third"
            />
            <img
                src="./images/homepage_rebrand/slider/weather.png"
                alt="Privacy widget"
                width="331"
                height="403"
                className="weather-widget"
            />
        </>
    );
};

export default HomepageSlideWeather;
